import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ModalController, NavController, ToastController} from '@ionic/angular';
import {
  AbstractPaymentLotDetail,
  PaymentLotDetailBillet, PaymentLotDetailOnUs, PaymentLotDetailTed,
  PaymentLotDto,
  PaymentLotService,
  PaymentLotTypeLotEnum,
  TransferService
} from '@wlp/ui-bs-cashout';
import {UserInfoService} from '@wlp/ui-bs-login';
import {UserInfoProfile} from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import {UiBsTranslateService} from '@wlp/ui-bs-translate';
import {LayoutConfigModel} from 'src/app/core/layout/models/layout-config.model';
import {LayoutConfigService} from 'src/app/core/layout/services/layout-config.service';
import {LoadingService} from '../../../../../../../core/layout/services/loading.service';
import * as moment from 'moment/moment';
import {ModalAlertComponent} from '../../../../modals/modal-alert/modal-alert.component';

@Component({
  selector: 'app-payment-lot',
  templateUrl: './payment-lot.page.html',
  styleUrls: ['./payment-lot.page.scss'],
})
export class PaymentLotPage implements OnInit, OnDestroy {

  public iconName: string | 'eye-off-outline' | 'eye-outline';

  public messages = [];

  @Input()
  public operation: string = '112';

  @Input()
  public userProfile: UserInfoProfile;

  @Input()
  public titleHeader: string = 'CASH_OUT.PAYMENT_LOT.HEADER.TITLE';

  @Input()
  public paymentLot: PaymentLotDto;

  @Input()
  public amountPaymentLot: number;

  @Input()
  public valuePaymentLot: number;

  @Output()
  public changeCanceledItem = new EventEmitter();

  @Output()
  public chanceCanceledLot = new EventEmitter();

  @Output()
  public changeProcessPayment = new EventEmitter();

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private toastController: ToastController,
    public loadingService: LoadingService,
    protected userInfoService: UserInfoService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private route: ActivatedRoute,
    private paymentLotService: PaymentLotService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

  }

  public datetimeControl(date: any): string {
    try {
      return `${moment(this.formattedDate(date)).format('DD/MM/YY HH:mm')}`;
    } catch (err) {
      return '';
    }
  }

  public dateControl(date: any): string {
    try {
      return `${moment(this.formattedDate(date)).format('DD/MM/YY')}`;
    } catch (err) {
      return '';
    }
  }

  private formattedDate(date) {
    if (date && typeof date === 'object' && date.constructor === Array) {
      if (date.length === 6) {
        return new Date(date[0], date[1] - 1, date[2], date[3], date[4], date[5]);
      } else if (date.length === 5) {
        return new Date(date[0], date[1] - 1, date[2], date[3], date[4]);
      }
      return new Date(date[0], date[1], date[2]);
    }
    return date;
  }

  public ngOnDestroy() {
    // this.destroy$.complete();
  }

  public continue(){
    this.changeProcessPayment.emit({payment: true});
  }

  public viewDetail(type: PaymentLotTypeLotEnum, transaction: AbstractPaymentLotDetail){

  }

  public changeCancelTransaction(paymentLotType: PaymentLotTypeLotEnum, uuid: string) {
    this.changeCanceledItem.emit({typeLot: paymentLotType, uuidTransation: uuid});
  }

  public changeCancelLot(paymentLotType: PaymentLotTypeLotEnum){
    this.chanceCanceledLot.emit({typeLot: paymentLotType});
  }





}
